import dayjs from "dayjs";

import { MailStatus, MailStatusProperties } from "../enums/MailStatus.ts";

export interface Mail {
  id: number;
  senderEmail: string;
  receiverEmail: string;
  subject: string;
  body: string;
  status: MailStatus;
  createdAt: Date;
  templateCode: string;
  ccs: string[];
  bccs: string[];
  attachmentUrls: string[];
  lastRetry: string;
}

export function canRetry(mail: Mail): boolean {
  const retryEligible = MailStatusProperties[mail.status].retryEligible;
  if (!retryEligible) return false;

  if (mail.status !== MailStatus.ACKNOWLEDGED) return true;

  const referenceDate = mail.lastRetry || mail.createdAt;

  const isYoungerThan24h = referenceDate && dayjs().diff(dayjs(referenceDate), "hour") < 24;

  return !isYoungerThan24h;
}
